module.exports = __webpack_public_path__ + "static/media/molveno.0485b57a.jpeg";